<template>
	<div>
		<ManagingSection header="이벤트 정보" :columnCount="2">
			<ManagingBox title="이벤트 번호">{{ info.idEvent }}</ManagingBox>
			<ManagingBox title="클라이언트"
				>{{ info.clientName }} ({{ info.idBrand }})</ManagingBox
			>
		</ManagingSection>
		<ManagingSection :splice="true">
			<ManagingBox title="제품 정보" :noPadding="true">
				<table v-if="hasEventProductList" class="table-main">
					<thead>
						<tr>
							<th>제품항번</th>
							<th>제품명</th>
							<th v-if="isEventType5">설문링크</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in info.products" :key="item.idProduct">
							<td>{{ item.idProduct }}</td>
							<td class="text-left">
								<RouterLink
									:to="`/product/product-inquiry/${item.idProduct}`"
									target="_blank"
									class="link"
								>
									{{ item.productTitle }}
								</RouterLink>
							</td>
							<td v-if="isEventType5">
								<input
									v-model="surveyLinkList[item.idProduct]"
									ref="surveyLinkInput"
									type="text"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</ManagingBox>
		</ManagingSection>
	</div>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';

	export default {
		name: 'EventWinnerPickEventInfo',
		components: {
			ManagingSection,
			ManagingBox,
		},
		props: {
			info: {
				default: null,
				type: Object,
			},
		},
		data() {
			return {
				surveyLinkList: {},
			};
		},
		computed: {
			hasEventProductList() {
				return this.info.products?.length;
			},
			isEventType5() {
				return this.info?.eventType === 5;
			},
		},
		created() {
			if (this.hasEventProductList && this.isEventType5) {
				this.info.eventProductList.forEach(item => {
					this.surveyLinkList[item.idProduct] = item.surveyLink || '';
				});
			}
		},
		methods: {
			hasEmptySurveyLink() {
				const inputList = this.$refs.surveyLinkInput;
				const targetIdx = inputList.findIndex(input => !input.value);
				if (targetIdx > -1) {
					inputList[targetIdx].focus();
					alert('제품별 설문링크를 모두 채워주세요!');
					return true;
				}
			},
		},
	};
</script>
